module.exports = __webpack_public_path__ + "img/quick-milk-tea.60d0742b.jpg";